/* tslint:disable */
/* eslint-disable */
/**
 * AI Secretary
 * AI-powered voice assistant platform for automated appointment scheduling, customer communication, and CRM integration
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { HTTPValidationError } from '../models';
// @ts-ignore
import type { PagePromptTemplateResponseDTO } from '../models';
// @ts-ignore
import type { PromptTemplateCreateDTO } from '../models';
// @ts-ignore
import type { PromptTemplateResponseDTO } from '../models';
// @ts-ignore
import type { PromptTemplateUpdateDTO } from '../models';
/**
 * PromptTemplatesApi - axios parameter creator
 * @export
 */
export const PromptTemplatesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create Prompt Template
         * @param {PromptTemplateCreateDTO} promptTemplateCreateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPromptTemplateApiV1PromptTemplatesPost: async (promptTemplateCreateDTO: PromptTemplateCreateDTO, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'promptTemplateCreateDTO' is not null or undefined
            assertParamExists('createPromptTemplateApiV1PromptTemplatesPost', 'promptTemplateCreateDTO', promptTemplateCreateDTO)
            const localVarPath = `/api/v1/prompt-templates/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(promptTemplateCreateDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create Prompt Template
         * @param {PromptTemplateCreateDTO} promptTemplateCreateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPromptTemplateApiV1PromptTemplatesPost_1: async (promptTemplateCreateDTO: PromptTemplateCreateDTO, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'promptTemplateCreateDTO' is not null or undefined
            assertParamExists('createPromptTemplateApiV1PromptTemplatesPost_1', 'promptTemplateCreateDTO', promptTemplateCreateDTO)
            const localVarPath = `/api/v1/prompt-templates/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(promptTemplateCreateDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete Prompt Template
         * @param {string} templateId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePromptTemplateApiV1PromptTemplatesTemplateIdDelete: async (templateId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'templateId' is not null or undefined
            assertParamExists('deletePromptTemplateApiV1PromptTemplatesTemplateIdDelete', 'templateId', templateId)
            const localVarPath = `/api/v1/prompt-templates/{template_id}`
                .replace(`{${"template_id"}}`, encodeURIComponent(String(templateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete Prompt Template
         * @param {string} templateId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePromptTemplateApiV1PromptTemplatesTemplateIdDelete_2: async (templateId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'templateId' is not null or undefined
            assertParamExists('deletePromptTemplateApiV1PromptTemplatesTemplateIdDelete_2', 'templateId', templateId)
            const localVarPath = `/api/v1/prompt-templates/{template_id}`
                .replace(`{${"template_id"}}`, encodeURIComponent(String(templateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Prompt Template
         * @param {string} templateId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPromptTemplateApiV1PromptTemplatesTemplateIdGet: async (templateId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'templateId' is not null or undefined
            assertParamExists('getPromptTemplateApiV1PromptTemplatesTemplateIdGet', 'templateId', templateId)
            const localVarPath = `/api/v1/prompt-templates/{template_id}`
                .replace(`{${"template_id"}}`, encodeURIComponent(String(templateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Prompt Template
         * @param {string} templateId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPromptTemplateApiV1PromptTemplatesTemplateIdGet_3: async (templateId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'templateId' is not null or undefined
            assertParamExists('getPromptTemplateApiV1PromptTemplatesTemplateIdGet_3', 'templateId', templateId)
            const localVarPath = `/api/v1/prompt-templates/{template_id}`
                .replace(`{${"template_id"}}`, encodeURIComponent(String(templateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List Prompt Templates
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPromptTemplatesApiV1PromptTemplatesGet: async (limit?: number, offset?: number, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/prompt-templates/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List Prompt Templates
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPromptTemplatesApiV1PromptTemplatesGet_4: async (limit?: number, offset?: number, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/prompt-templates/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Prompt Template
         * @param {string} templateId 
         * @param {PromptTemplateUpdateDTO} promptTemplateUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePromptTemplateApiV1PromptTemplatesTemplateIdPatch: async (templateId: string, promptTemplateUpdateDTO: PromptTemplateUpdateDTO, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'templateId' is not null or undefined
            assertParamExists('updatePromptTemplateApiV1PromptTemplatesTemplateIdPatch', 'templateId', templateId)
            // verify required parameter 'promptTemplateUpdateDTO' is not null or undefined
            assertParamExists('updatePromptTemplateApiV1PromptTemplatesTemplateIdPatch', 'promptTemplateUpdateDTO', promptTemplateUpdateDTO)
            const localVarPath = `/api/v1/prompt-templates/{template_id}`
                .replace(`{${"template_id"}}`, encodeURIComponent(String(templateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(promptTemplateUpdateDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Prompt Template
         * @param {string} templateId 
         * @param {PromptTemplateUpdateDTO} promptTemplateUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePromptTemplateApiV1PromptTemplatesTemplateIdPatch_5: async (templateId: string, promptTemplateUpdateDTO: PromptTemplateUpdateDTO, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'templateId' is not null or undefined
            assertParamExists('updatePromptTemplateApiV1PromptTemplatesTemplateIdPatch_5', 'templateId', templateId)
            // verify required parameter 'promptTemplateUpdateDTO' is not null or undefined
            assertParamExists('updatePromptTemplateApiV1PromptTemplatesTemplateIdPatch_5', 'promptTemplateUpdateDTO', promptTemplateUpdateDTO)
            const localVarPath = `/api/v1/prompt-templates/{template_id}`
                .replace(`{${"template_id"}}`, encodeURIComponent(String(templateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(promptTemplateUpdateDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PromptTemplatesApi - functional programming interface
 * @export
 */
export const PromptTemplatesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PromptTemplatesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create Prompt Template
         * @param {PromptTemplateCreateDTO} promptTemplateCreateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPromptTemplateApiV1PromptTemplatesPost(promptTemplateCreateDTO: PromptTemplateCreateDTO, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PromptTemplateResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPromptTemplateApiV1PromptTemplatesPost(promptTemplateCreateDTO, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PromptTemplatesApi.createPromptTemplateApiV1PromptTemplatesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create Prompt Template
         * @param {PromptTemplateCreateDTO} promptTemplateCreateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPromptTemplateApiV1PromptTemplatesPost_1(promptTemplateCreateDTO: PromptTemplateCreateDTO, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PromptTemplateResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPromptTemplateApiV1PromptTemplatesPost_1(promptTemplateCreateDTO, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PromptTemplatesApi.createPromptTemplateApiV1PromptTemplatesPost_1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete Prompt Template
         * @param {string} templateId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePromptTemplateApiV1PromptTemplatesTemplateIdDelete(templateId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePromptTemplateApiV1PromptTemplatesTemplateIdDelete(templateId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PromptTemplatesApi.deletePromptTemplateApiV1PromptTemplatesTemplateIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete Prompt Template
         * @param {string} templateId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePromptTemplateApiV1PromptTemplatesTemplateIdDelete_2(templateId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePromptTemplateApiV1PromptTemplatesTemplateIdDelete_2(templateId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PromptTemplatesApi.deletePromptTemplateApiV1PromptTemplatesTemplateIdDelete_2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Prompt Template
         * @param {string} templateId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPromptTemplateApiV1PromptTemplatesTemplateIdGet(templateId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PromptTemplateResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPromptTemplateApiV1PromptTemplatesTemplateIdGet(templateId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PromptTemplatesApi.getPromptTemplateApiV1PromptTemplatesTemplateIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Prompt Template
         * @param {string} templateId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPromptTemplateApiV1PromptTemplatesTemplateIdGet_3(templateId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PromptTemplateResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPromptTemplateApiV1PromptTemplatesTemplateIdGet_3(templateId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PromptTemplatesApi.getPromptTemplateApiV1PromptTemplatesTemplateIdGet_3']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List Prompt Templates
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listPromptTemplatesApiV1PromptTemplatesGet(limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagePromptTemplateResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listPromptTemplatesApiV1PromptTemplatesGet(limit, offset, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PromptTemplatesApi.listPromptTemplatesApiV1PromptTemplatesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List Prompt Templates
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listPromptTemplatesApiV1PromptTemplatesGet_4(limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagePromptTemplateResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listPromptTemplatesApiV1PromptTemplatesGet_4(limit, offset, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PromptTemplatesApi.listPromptTemplatesApiV1PromptTemplatesGet_4']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update Prompt Template
         * @param {string} templateId 
         * @param {PromptTemplateUpdateDTO} promptTemplateUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePromptTemplateApiV1PromptTemplatesTemplateIdPatch(templateId: string, promptTemplateUpdateDTO: PromptTemplateUpdateDTO, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PromptTemplateResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePromptTemplateApiV1PromptTemplatesTemplateIdPatch(templateId, promptTemplateUpdateDTO, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PromptTemplatesApi.updatePromptTemplateApiV1PromptTemplatesTemplateIdPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update Prompt Template
         * @param {string} templateId 
         * @param {PromptTemplateUpdateDTO} promptTemplateUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePromptTemplateApiV1PromptTemplatesTemplateIdPatch_5(templateId: string, promptTemplateUpdateDTO: PromptTemplateUpdateDTO, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PromptTemplateResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePromptTemplateApiV1PromptTemplatesTemplateIdPatch_5(templateId, promptTemplateUpdateDTO, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PromptTemplatesApi.updatePromptTemplateApiV1PromptTemplatesTemplateIdPatch_5']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PromptTemplatesApi - factory interface
 * @export
 */
export const PromptTemplatesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PromptTemplatesApiFp(configuration)
    return {
        /**
         * 
         * @summary Create Prompt Template
         * @param {PromptTemplateCreateDTO} promptTemplateCreateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPromptTemplateApiV1PromptTemplatesPost(promptTemplateCreateDTO: PromptTemplateCreateDTO, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<PromptTemplateResponseDTO> {
            return localVarFp.createPromptTemplateApiV1PromptTemplatesPost(promptTemplateCreateDTO, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create Prompt Template
         * @param {PromptTemplateCreateDTO} promptTemplateCreateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPromptTemplateApiV1PromptTemplatesPost_1(promptTemplateCreateDTO: PromptTemplateCreateDTO, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<PromptTemplateResponseDTO> {
            return localVarFp.createPromptTemplateApiV1PromptTemplatesPost_1(promptTemplateCreateDTO, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete Prompt Template
         * @param {string} templateId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePromptTemplateApiV1PromptTemplatesTemplateIdDelete(templateId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deletePromptTemplateApiV1PromptTemplatesTemplateIdDelete(templateId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete Prompt Template
         * @param {string} templateId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePromptTemplateApiV1PromptTemplatesTemplateIdDelete_2(templateId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deletePromptTemplateApiV1PromptTemplatesTemplateIdDelete_2(templateId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Prompt Template
         * @param {string} templateId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPromptTemplateApiV1PromptTemplatesTemplateIdGet(templateId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<PromptTemplateResponseDTO> {
            return localVarFp.getPromptTemplateApiV1PromptTemplatesTemplateIdGet(templateId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Prompt Template
         * @param {string} templateId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPromptTemplateApiV1PromptTemplatesTemplateIdGet_3(templateId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<PromptTemplateResponseDTO> {
            return localVarFp.getPromptTemplateApiV1PromptTemplatesTemplateIdGet_3(templateId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List Prompt Templates
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPromptTemplatesApiV1PromptTemplatesGet(limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<PagePromptTemplateResponseDTO> {
            return localVarFp.listPromptTemplatesApiV1PromptTemplatesGet(limit, offset, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List Prompt Templates
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPromptTemplatesApiV1PromptTemplatesGet_4(limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<PagePromptTemplateResponseDTO> {
            return localVarFp.listPromptTemplatesApiV1PromptTemplatesGet_4(limit, offset, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Prompt Template
         * @param {string} templateId 
         * @param {PromptTemplateUpdateDTO} promptTemplateUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePromptTemplateApiV1PromptTemplatesTemplateIdPatch(templateId: string, promptTemplateUpdateDTO: PromptTemplateUpdateDTO, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<PromptTemplateResponseDTO> {
            return localVarFp.updatePromptTemplateApiV1PromptTemplatesTemplateIdPatch(templateId, promptTemplateUpdateDTO, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Prompt Template
         * @param {string} templateId 
         * @param {PromptTemplateUpdateDTO} promptTemplateUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePromptTemplateApiV1PromptTemplatesTemplateIdPatch_5(templateId: string, promptTemplateUpdateDTO: PromptTemplateUpdateDTO, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<PromptTemplateResponseDTO> {
            return localVarFp.updatePromptTemplateApiV1PromptTemplatesTemplateIdPatch_5(templateId, promptTemplateUpdateDTO, authorization, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PromptTemplatesApi - object-oriented interface
 * @export
 * @class PromptTemplatesApi
 * @extends {BaseAPI}
 */
export class PromptTemplatesApi extends BaseAPI {
    /**
     * 
     * @summary Create Prompt Template
     * @param {PromptTemplateCreateDTO} promptTemplateCreateDTO 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromptTemplatesApi
     */
    public createPromptTemplateApiV1PromptTemplatesPost(promptTemplateCreateDTO: PromptTemplateCreateDTO, authorization?: string, options?: RawAxiosRequestConfig) {
        return PromptTemplatesApiFp(this.configuration).createPromptTemplateApiV1PromptTemplatesPost(promptTemplateCreateDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create Prompt Template
     * @param {PromptTemplateCreateDTO} promptTemplateCreateDTO 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromptTemplatesApi
     */
    public createPromptTemplateApiV1PromptTemplatesPost_1(promptTemplateCreateDTO: PromptTemplateCreateDTO, authorization?: string, options?: RawAxiosRequestConfig) {
        return PromptTemplatesApiFp(this.configuration).createPromptTemplateApiV1PromptTemplatesPost_1(promptTemplateCreateDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete Prompt Template
     * @param {string} templateId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromptTemplatesApi
     */
    public deletePromptTemplateApiV1PromptTemplatesTemplateIdDelete(templateId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return PromptTemplatesApiFp(this.configuration).deletePromptTemplateApiV1PromptTemplatesTemplateIdDelete(templateId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete Prompt Template
     * @param {string} templateId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromptTemplatesApi
     */
    public deletePromptTemplateApiV1PromptTemplatesTemplateIdDelete_2(templateId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return PromptTemplatesApiFp(this.configuration).deletePromptTemplateApiV1PromptTemplatesTemplateIdDelete_2(templateId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Prompt Template
     * @param {string} templateId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromptTemplatesApi
     */
    public getPromptTemplateApiV1PromptTemplatesTemplateIdGet(templateId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return PromptTemplatesApiFp(this.configuration).getPromptTemplateApiV1PromptTemplatesTemplateIdGet(templateId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Prompt Template
     * @param {string} templateId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromptTemplatesApi
     */
    public getPromptTemplateApiV1PromptTemplatesTemplateIdGet_3(templateId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return PromptTemplatesApiFp(this.configuration).getPromptTemplateApiV1PromptTemplatesTemplateIdGet_3(templateId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List Prompt Templates
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromptTemplatesApi
     */
    public listPromptTemplatesApiV1PromptTemplatesGet(limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig) {
        return PromptTemplatesApiFp(this.configuration).listPromptTemplatesApiV1PromptTemplatesGet(limit, offset, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List Prompt Templates
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromptTemplatesApi
     */
    public listPromptTemplatesApiV1PromptTemplatesGet_4(limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig) {
        return PromptTemplatesApiFp(this.configuration).listPromptTemplatesApiV1PromptTemplatesGet_4(limit, offset, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Prompt Template
     * @param {string} templateId 
     * @param {PromptTemplateUpdateDTO} promptTemplateUpdateDTO 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromptTemplatesApi
     */
    public updatePromptTemplateApiV1PromptTemplatesTemplateIdPatch(templateId: string, promptTemplateUpdateDTO: PromptTemplateUpdateDTO, authorization?: string, options?: RawAxiosRequestConfig) {
        return PromptTemplatesApiFp(this.configuration).updatePromptTemplateApiV1PromptTemplatesTemplateIdPatch(templateId, promptTemplateUpdateDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Prompt Template
     * @param {string} templateId 
     * @param {PromptTemplateUpdateDTO} promptTemplateUpdateDTO 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromptTemplatesApi
     */
    public updatePromptTemplateApiV1PromptTemplatesTemplateIdPatch_5(templateId: string, promptTemplateUpdateDTO: PromptTemplateUpdateDTO, authorization?: string, options?: RawAxiosRequestConfig) {
        return PromptTemplatesApiFp(this.configuration).updatePromptTemplateApiV1PromptTemplatesTemplateIdPatch_5(templateId, promptTemplateUpdateDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }
}

